/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=50750084&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/frontend_prod_master@2/project/wfzx-platform-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50750084"]])

export default __exports__